import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProxyServiceType } from "../../../../AddProxyService/components/types";

import { styledHeaderText } from "../../../../styled";

import { DialogContextType } from "../../../../DialogComponents/FullScreenDialog";

export const useContext = (isProxyLayer?: boolean, serviceType?: ProxyServiceType): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      isProxyLayer
        ? {
            title: {
              text: styledHeaderText(
                t("editResource.proxyServiceProperties", { ns: "dialogs" }).replace("{serviceType}", serviceType),
              ),
              icon: "settings",
            },
            meta: {
              aliasLabel: t("editResource.proxyServiceTitle", { ns: "dialogs" }),
              descriptionLabel: t("description", { ns: "common" }),
              loaderLabel: t("editResource.uploadImage", { ns: "dialogs" }),
            },
            applyText: t("actions.save", { ns: "common" }),
            attributes: {
              label: t("editResource.setLayers", { ns: "dialogs" }),
              description: t("editResource.setProxyServiceLayers", { ns: "dialogs" }),
              icon: "layers",
            },
          }
        : {
            title: {
              text: styledHeaderText(t("editResource.layerProperties", { ns: "dialogs" })),
              icon: "settings",
            },
            meta: {
              aliasLabel: t("editResource.layerName", { ns: "dialogs" }),
              descriptionLabel: t("editResource.layerDescription", { ns: "dialogs" }),
              loaderLabel: t("editResource.uploadImage", { ns: "dialogs" }),
            },
            applyText: t("actions.save", { ns: "common" }),
            attributes: {
              label: t("editResource.attributes", { ns: "dialogs" }),
              description: t("editResource.attributesDescription", { ns: "dialogs" }),
              icon: "table",
            },
          },
    [isProxyLayer, t],
  );
};
